import { useProvider } from "wagmi"
import { useCallback, useEffect, useState } from "react"

import { useAddress } from "web3/hooks/useAddress"
import { isSolanaAddress } from "web3/helpers/address"

const useIsContract = (
  address?: string,
  chainId?: number,
): {
  isContract: boolean
  isLoading: boolean
} => {
  const accountAddress = useAddress()

  const provider = useProvider({ chainId })
  const [isContract, setIsContract] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const check = useCallback(
    async (_address: string) => {
      setIsLoading(true)
      const code = await provider.getCode(_address)
      setIsContract(code !== "0x")
      setIsLoading(false)
    },
    [provider],
  )

  useEffect(() => {
    if (isSolanaAddress(address as string)) {
      setIsContract(false)
      setIsLoading(false)

      return
    }

    const checkIsContract = async () => {
      if (!accountAddress || address) return
      check(accountAddress)
    }

    const checkIsAddressInputContract = async () => {
      if (!address) return
      check(address)
    }

    checkIsContract()
    checkIsAddressInputContract()
  }, [accountAddress, provider, check, address])

  return { isContract, isLoading }
}

export default useIsContract
